module.exports = __webpack_public_path__ + "static/media/titulo_contraportada.54083656.png";